import { render, staticRenderFns } from "./ListCatalog.vue?vue&type=template&id=1b7d5661&scoped=true&"
import script from "./ListCatalog.vue?vue&type=script&lang=js&"
export * from "./ListCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ListCatalog.vue?vue&type=style&index=0&id=1b7d5661&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d5661",
  null
  
)

export default component.exports